/* eslint-disable react/no-children-prop */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState, useEffect } from "react";
import { getContactUsDetails } from "./requestCall";
import Markdown from "markdown-to-jsx";
import { v4 } from "uuid";
import styled from "@emotion/styled";

const emailInfo = css`
  &:hover {
    cursor: pointer;
    color: blue;
  }
  width: fit-content;
  color: white;
  text-decoration: none;
`;
const contentWrapper = css`
  display: block;
  font-size: 14px;
  line-height: 35px;
  img {
    width: 100%;
  }
`;

const contactUsStyle = {
  text: {
    minWidth: "226px",
    position: "absolute",
    top: "18%",
    left: "5%",
    color: "#fff",
  },
  text_mobile: {
    fontSize: "30px",
    fontWeight: "400",
    letterSpacing: "1px",
    position: "relative",
    left: "5%",
    marginTop: "3%",
  },
  rtContainer: {
    inlineSize: "45%",
    overflowWrap: "break-word",
  },
};

const CardWrapper = styled(CardContent)(({ mobileview }) => ({
  display: "flex",
  flexDirection: mobileview ? "column" : "row",
  justifyContent: "space-between",
  margin: "2%",
}));

const RichTextBox = styled(Box)(({ mobileview }) => ({
  inlineSize: mobileview ? "100%" : "45%",
  overflowWrap: "break-word",
}));

const ContactUs = () => {
  const [contactUsBanner, setContactUsBanner] = useState();
  const [contactUsDetail, setContactUsDetail] = useState([]);

  useEffect(() => {
    getContactUsDetails().then((response) => {
      document.title = response?.data?.data?.attributes?.title;
      const temp = [];
      response?.data?.data?.attributes?.body.map((item) => {
        if (item.__component === "shared.image-banner") {
          setContactUsBanner(item);
        } else {
          temp.push(item);
        }
      });
      setContactUsDetail([...temp]);
    });
  }, []);

  const matches = useMediaQuery("(max-width: 480px)");
  const imageUrl =
    contactUsBanner?.media?.data?.attributes?.formats?.large?.url ||
    contactUsBanner?.media?.data?.attributes?.formats?.small?.url ||
    contactUsBanner?.media?.data?.attributes?.formats?.thumbnail?.url;

  return (
    <Card style={{ background: "#121212" }}>
      <Box sx={{ display: { xs: "none", md: "flex" } }}>
        <Typography variant="h2" sx={{ ...contactUsStyle.text }} gutterBottom>
          {contactUsBanner?.title}
        </Typography>

        <CardMedia
          component="img"
          image={`${process.env.REACT_APP_BASEURL}${imageUrl}`}
          alt="Contact Us Banner"
          height="400"
        />
      </Box>
      <Box
        sx={{
          display: { xs: "flex", md: "none", flexDirection: "column" },
          color: "white",
        }}
      >
        <CardMedia
          component="img"
          image={`${process.env.REACT_APP_BASEURL}${imageUrl}`}
          alt="Contact Us Banner"
          height="200"
        />
        <Typography
          variant="h5"
          component="div"
          gutterBottom
          sx={{ ...contactUsStyle.text_mobile }}
        >
          {contactUsBanner?.title}
        </Typography>
      </Box>
      <CardWrapper style={{ color: "white" }} mobileview={matches ? 1 : 0}>
        {contactUsDetail &&
          contactUsDetail?.map((d) => (
            <RichTextBox key={v4()} pb={2} mobileview={matches ? 1 : 0}>
              <Typography pb={2} variant="h5">
                {d?.title + " "}
                {d?.subtitle && (
                  <Typography variant="body2" component="span">
                    {d?.subtitle}
                  </Typography>
                )}
              </Typography>
              {d?.phoneNumber && (
                <Typography
                  css={emailInfo}
                  variant="h5"
                  component="a"
                  href={`tel:${d?.phoneNumber}`}
                >
                  {d?.phoneNumber}
                </Typography>
              )}
              {d?.emailId && (
                <Typography
                  css={emailInfo}
                  variant="h5"
                  component="a"
                  href={`mailto:${d?.emailId}`}
                >
                  {d?.emailId}
                </Typography>
              )}
              <Markdown css={contentWrapper}>
                {(process.env.REACT_APP_BASEURL.includes("localhost")
                  ? d.description?.replaceAll(
                      "/uploads/",
                      `${process.env.REACT_APP_BASEURL}/uploads/`
                    )
                  : d.description) || ""}
              </Markdown>
            </RichTextBox>
          ))}
      </CardWrapper>
    </Card>
  );
};

export default ContactUs;
